import React from 'react'

const SlideOverBody = (props) => {
    return (
        <div className="relative p-4 md:p-6 flex-1 min-h-0 overflow-y-auto transition-opacity duration-200">
            {props.children}
        </div>
    )
}

export default SlideOverBody